import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const GET_HOW_TO_DOCUMENTATION_REQUEST = 'GET_HOW_TO_DOCUMENTATION_REQUEST'
export const GET_HOW_TO_DOCUMENTATION_SUCCESS = 'GET_HOW_TO_DOCUMENTATION_SUCCESS'
export const GET_HOW_TO_DOCUMENTATION_FAILURE = 'GET_HOW_TO_DOCUMENTATION_FAILURE'

export const GET_CLIENT_SUPPORT_DOCUMENTS_REQUEST = 'GET_CLIENT_SUPPORT_DOCUMENTS_REQUEST'
export const GET_CLIENT_SUPPORT_DOCUMENTS_SUCCESS = 'GET_CLIENT_SUPPORT_DOCUMENTS_SUCCESS'
export const GET_CLIENT_SUPPORT_DOCUMENTS_FAILURE = 'GET_CLIENT_SUPPORT_DOCUMENTS_FAILURE'

export const fetchHowToDocumentation = () => ({
  [CALL_API]: {
    endpoint: `/api/master-document/how-to/`,
    types: [GET_HOW_TO_DOCUMENTATION_REQUEST, GET_HOW_TO_DOCUMENTATION_SUCCESS, GET_HOW_TO_DOCUMENTATION_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const fetchClientSupportDocuments = () => ({
  [CALL_API]: {
    endpoint: `/api/master-document/client-support-documents/`,
    types: [
      GET_CLIENT_SUPPORT_DOCUMENTS_REQUEST,
      GET_CLIENT_SUPPORT_DOCUMENTS_SUCCESS,
      GET_CLIENT_SUPPORT_DOCUMENTS_FAILURE,
    ],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
